module.exports = __webpack_public_path__ + "img/article-default-cover.dab96843.png";